var deviceScreen = $('.device-container');

/* DEVICE SCROLLER
--------------------------- */
// Fire active class on device image for scroll
$('#device-wrapper')
  .waypoint(function(direction) {
    if (direction === 'down') {
      // add active class
      deviceScreen.addClass('is-active');
    } else {
      // when scrolling back up stop active class and add before class for default position
      deviceScreen.removeClass('is-active').addClass('before-start');
    }
  }, { offset: '25px' });

// Stop device image scroll once last section comes into view.
$('.section-four')
  .waypoint(function(direction) {
    if (direction === 'down') {
      // when bottom of section remove active class and hold device image at last section
      deviceScreen.removeClass('is-active').addClass('is-complete');
    } else {
      // resume scrolling device image
      deviceScreen.addClass('is-active').removeClass('is-complete');
    }
  }, { offset: '0' });


/* PLAY VIDEOS WHEN SCROLLING
---------------------------------- */
var video1_container = document.getElementById("video1"),
    video2_container = document.getElementById("video2"),
    video3_container = document.getElementById("video3"),
    video4_container = document.getElementById("video4"),
    video1 = document.getElementById("video_1"),
    video2 = document.getElementById("video_2"),
    video3 = document.getElementById("video_3"),
    video4 = document.getElementById("video_4");

$('.section-one')
  .waypoint(function(direction) {
    if (direction === 'down') {
      //video1_container.style.visibility = "visible";
      video1_container.classList.add('video-is-active');
      video1.play();
    } else {
      // nothing.
      video1.pause();
      video1.currentTime = 0;
    }
  }, { offset: '20%' });

$('.section-two')
  .waypoint(function(direction) {
    if (direction === 'down') {
      //video1_container.style.visibility = "visible";
      video2_container.classList.add('video-is-active');
      video2.play();
    }  else {
      video2_container.classList.remove('video-is-active');
      video2.pause();
      video2.currentTime = 0;
    }
  }, { offset: '20%' });

$('.section-three')
  .waypoint(function(direction) {
    if (direction === 'down') {
      //video1_container.style.visibility = "visible";
      video3_container.classList.add('video-is-active');
      video3.play();
    } else {
      video3_container.classList.remove('video-is-active');
      video3.pause();
      video3.currentTime = 0;
    }
  }, { offset: '20%' });

$('.section-four')
  .waypoint(function(direction) {
    if (direction === 'down') {
      //video1_container.style.visibility = "visible";
      video4_container.classList.add('video-is-active');
      video4.play();
    } else {
      video4_container.classList.remove('video-is-active');
      video4.pause();
      video4.currentTime = 0;
    }
  }, { offset: '20%' });


// Banner Video Toggle
var starterVideo = document.getElementById('banner-video-starter'),
    loopVideo = document.getElementById('banner-video-loop'),
    bannerContent = document.getElementById('bannerContent');

loopVideo.style.opacity = 0;

starterVideo.play()

starterVideo.addEventListener('playing', function() {
  window.setTimeout(function() {
    bannerContent.classList.add('content-visible');
  }, 2000);
});

starterVideo.addEventListener('ended', function() {
  loopVideo.style.opacity = 1;
  starterVideo.style.opacity = 0;
});


// Scroll Content to Center
// ---------------------------------- */
function scrollCenterContent(itemContainer, offset) {
  $(itemContainer).each(function(i, section) {
    var content = $(section).parent();
    var h = $(content).height() - $(section).height() - offset;
    $(section).css("margin-top", h / 2);
  });
}

function scrollToCenter() {
  windowWidth = $(window).width();
  if (windowWidth <= 860) {
    $(".page-section .grid-container").css('margin-top',0);
  } else {
    scrollCenterContent(".page-section .grid-container", 0);
  }
}

function detectIpad() {
    IS_IPAD = navigator.userAgent.match(/iPad/i) != null;
    IS_ANDROID = $c.ANDROID;
    IS_IPHONE = navigator.userAgent.match(/iPhone/i) != null || navigator.userAgent.match(/iPod/i) != null;
    if (IS_IPAD) {
        IS_IPHONE = false;
        //$("#banner-video-starter, #banner-video-loop").css({ display: "none" });
        $("#banner-video-starter, #banner-video-loop").remove();
        $(".content-area").css({ opacity: "1" });
    }
    if (IS_IPHONE) {
        IS_IPAD = false;
        // $("#banner-video-starter, #banner-video-loop").css({ display: "none" });
        $("#banner-video-starter, #banner-video-loop").remove();
        $(".content-area").css({ opacity: "1" });
    }
    if (IS_ANDROID) {
        IS_IPAD = false;
        IS_IPHONE = false;
        //$("#banner-video-starter, #banner-video-loop").css({ display: "none" });
        $("#banner-video-starter, #banner-video-loop").remove();
        $(".content-area").css({ opacity: "1" });
    }
}

$(document).ready( function() {
  // Center content in <DIV>
  scrollToCenter();
  detectIpad();

  // Creates a smooth click and scroll based on hash
  $('a[href*=#]:not([href=#])').click(function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top
        }, 800);
        return false;
      }
    }
  });

});

// Window.resize do these
$(window).resize(function(){
  scrollToCenter();
});

// Detect image natural size and prevent from being too large in responsive view
$(window).load(function(){
  detectIpad();

  if('naturalWidth'in(new Image)){
    $('img').each(function(){
      var width=$(this)[0].naturalWidth;
      $(this).css('max-width',width);
    });
  }
});
